export enum DASHBOARD_DATE_FILTER_TYPE {
  LAST_7_DAYS = '7d',
  LAST_14_DAYS = '14d',
  LAST_30_DAYS = '30d',
  LAST_4_WEEKS = '4w',
  LAST_8_WEEKS = '8w',
  LAST_12_WEEKS = '12w',
  LAST_3_MONTHS = '3m',
  LAST_6_MONTHS = '6m',
  LAST_12_MONTHS = '12m',
  CUSTOM = 'Custom',
}

export enum DASHBOARD_DATE_FILTER_UNIT {
  DAY = 'Daily',
  WEEK = 'Weekly',
  MONTH = 'Monthly',
}

export const DAILY_PRESETS = [
  DASHBOARD_DATE_FILTER_TYPE.LAST_7_DAYS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_14_DAYS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_30_DAYS,
];

export const WEEKLY_PRESETS = [
  DASHBOARD_DATE_FILTER_TYPE.LAST_4_WEEKS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_8_WEEKS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_12_WEEKS,
];

export const MONTHLY_PRESETS = [
  DASHBOARD_DATE_FILTER_TYPE.LAST_3_MONTHS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_6_MONTHS,
  DASHBOARD_DATE_FILTER_TYPE.LAST_12_MONTHS,
];
